import React from "react";
import FingerScanComp from "../../components/FingerScan/collectFingerPrint.component";

export default class FingerScanScreen extends React.Component {
  render() {
    return <FingerScanComp />;
  }
}
